module.exports = __webpack_public_path__ + "img/banner1.a9c52d06.png";